module.exports = __webpack_public_path__ + "assets/images/XCD5.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/XCD5.png
// module id = 1478
// module chunks = 1